import { useEffect, useState } from "react";
import { api } from "./api";

// Index revendeurs (mis en cache) pour retrouver le compte d'un client depuis un document.
let cache = null;

const load = () => {
  if (!cache) {
    cache = api.get("/resellers?include_archived=true")
      .then(({ data }) => {
        const byId = {};
        const byDistributor = {};
        (data || []).forEach((r) => {
          byId[r.id] = r.id;
          if (r.linked_distributor_id) byDistributor[r.linked_distributor_id] = r.id;
        });
        return { byId, byDistributor };
      })
      .catch(() => { cache = null; return { byId: {}, byDistributor: {} }; });
  }
  return cache;
};

export const useResellerLookup = () => {
  const [idx, setIdx] = useState(null);
  useEffect(() => { let alive = true; load().then((i) => alive && setIdx(i)); return () => { alive = false; }; }, []);
  return (resellerId, distributorId) => {
    if (!idx) return null;
    return (resellerId && idx.byId[resellerId]) || (distributorId && idx.byDistributor[distributorId]) || null;
  };
};
